import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GruppoCollegamenti {
  etichetta?: string;
  voci: string[];
}

export interface SezioneCollegamenti {
  titolo: string;
  suggerimento: string;
  gruppi: GruppoCollegamenti[];
}

export interface EliminazioneBloccataData {
  titolo: string;
  messaggio: string;
  sezioni: SezioneCollegamenti[];
}

/**
 * Spiega perche' un oggetto del PSA non puo' essere eliminato, elencando i collegamenti che lo impediscono
 */
@Component({
  selector: 'ebw-monorepo-eliminazione-bloccata-dialog',
  templateUrl: './eliminazione-bloccata-dialog.component.html',
  styleUrls: ['./eliminazione-bloccata-dialog.component.scss']
})
export class EliminazioneBloccataDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EliminazioneBloccataData,
    private _dialogRef: MatDialogRef<EliminazioneBloccataDialogComponent>
  ) {}

  totaleVoci(sezione: SezioneCollegamenti): number {
    return sezione.gruppi.reduce((totale, gruppo) => totale + gruppo.voci.length, 0);
  }

  chiudi(): void {
    this._dialogRef.close();
  }
}
